import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/utils/snackBar.service';

@Component({
  selector: 'app-modal-confirmacion',
  templateUrl: './modal-confirmacion.component.html',
  styleUrls: ['./modal-confirmacion.component.css']
})
export class ModalConfirmacionComponent implements OnInit {
  objeto: any;
  opcionSeleccionada: number = 0;
  patologiaSeleccionada: number = 0;
  mostrarSelectorPatologia: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalConfirmacionComponent>,
    public dialog: MatDialog,
    private _snackBar: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.objeto = this.data;
    if (this.objeto.opciones && this.objeto.opciones.length > 0) {
      this.opcionSeleccionada = this.objeto.opciones[0].Id;
      this.verificarSiRequierePatologia();
    }
    
    // Si viene idIncidenciaSeleccionada directamente (1 sola opción)
    if (this.objeto.idIncidenciaSeleccionada) {
      this.opcionSeleccionada = this.objeto.idIncidenciaSeleccionada;
      this.verificarSiRequierePatologia();
    }
  }

  ngOnInit() {
  }

  onSeleccionIncidencia(event: any) {
    this.opcionSeleccionada = event.value;
    this.verificarSiRequierePatologia();
  }

  verificarSiRequierePatologia() {
    if (!this.objeto.mostrarPatologias) {
      this.mostrarSelectorPatologia = false;
      return;
    }

    // Buscar si la incidencia seleccionada requiere patología
    if (this.objeto.opciones && this.objeto.opciones.length > 0) {
      const incidenciaSeleccionada = this.objeto.opciones.find(o => o.Id === this.opcionSeleccionada);
      this.mostrarSelectorPatologia = incidenciaSeleccionada && incidenciaSeleccionada.IdPreSet === 1;
    } else if (this.objeto.idIncidenciaSeleccionada && this.objeto.mostrarPatologias) {
      // Caso de 1 sola incidencia que ya viene seleccionada
      this.mostrarSelectorPatologia = true;
    }

    console.log('[MODAL-COMPONENT] Mostrar selector patología:', this.mostrarSelectorPatologia);
  }

  onSeleccionPatologia(event: any) {
    this.patologiaSeleccionada = event.value;
    console.log('[MODAL-COMPONENT] Patología seleccionada:', this.patologiaSeleccionada);
  }

  cerrarModal(estado) {
    // Validar que si requiere patología, se haya seleccionado una
    if (estado && this.mostrarSelectorPatologia && (!this.patologiaSeleccionada || this.patologiaSeleccionada === 0)) {
      this._snackBar.openSnackBar('snack-danger', 'Debe seleccionar una patología', 3000);
      return;
    }

    if (this.objeto.esSeleccion && estado) {
      // Retornar objeto con incidencia y patología
      this.dialogRef.close({
        idIncidenciaSeleccionada: this.opcionSeleccionada,
        idPatologiaSeleccionada: this.patologiaSeleccionada || 0
      });
    } else if (estado) {
      // Confirmación simple, retornar objeto
      this.dialogRef.close({
        confirmado: true,
        idPatologiaSeleccionada: this.patologiaSeleccionada || 0
      });
    } else {
      this.dialogRef.close(false);
    }
  }

  cerrarConEscape(event: KeyboardEvent) {
    if (this.objeto.novedadesConfirmacion) {
      event.stopPropagation();
      this.cerrarModal(false);
    }
  }

}

export interface DialogData {
  titulo: string;
  esHtml?: boolean;
  opciones?: any[];
  esSeleccion?: boolean;
  infoFechas?: {
    desde: Date;
    hasta: Date;
    dias: number;
    retorno: Date;
  };
  mostrarPatologias?: boolean;
  patologias?: any[];
  idIncidenciaSeleccionada?: number;
}
